import { Component,HostListener } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';//获取手机硬件设备
import { Platform, MenuController, NavController,IonApp,AlertController,ModalController,ActionSheetController,PopoverController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { BaseModal } from '../../src/model/base';
import { Router, NavigationEnd, NavigationStart, NavigationError, NavigationCancel } from '@angular/router';
import { CommonService } from '../service/common.service';
import { MessageclientService } from '../service/messageclient.service';
import { Subscription } from 'rxjs';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { AppMinimize } from '@ionic-native/app-minimize/ngx';//最小化
import { AppServiceBaseCase } from './app.service.basecase';
import { HttpCustomerService} from '../service/httpcustomer.service';//请求地址
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';//键盘事件
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { NativeService} from '../service/native.service';//硬件调用
import { EmitserviceService } from 'src/service/emitservice.service';
import { WebParameterContext } from 'src/model/common';
import {SysAccount} from "src/model/sys.account";
declare var app;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  providers: [AppMinimize, IonApp,AppServiceBaseCase]
})
export class AppComponent {
  public appPages: Array<any> = [];
  public userinfo: any;
  sideMenuDisabled = true;
  backButtonPressed: boolean = false; //用于判断返回键是否触发
  backExitApp: boolean = false;//用于判断是否双击触发
  customBackActionSubscription: Subscription;
  isAndroidPlatform:boolean = false;//安卓平台
  isIosPlatform:boolean = false;//ios平台
  isbackButton:boolean = false;//判断是否弹出
  isAndroid4:boolean = false;//是否是安卓4以下
  isAndroid5Down:boolean = false;//是否是安卓5以下
  isAndroid5:boolean = false;//是否是安卓5
  url: string;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public base: BaseModal,
    private router: Router,
    private menusC: MenuController,
    public navController: NavController,//导航控制器
    private common: CommonService,
    private msg: MessageclientService,
    private screen: ScreenOrientation,
    private appMinimize: AppMinimize,//最小化
    private appversion:AppVersion,//版本号
    private iab:InAppBrowser,//跳转链接
    private http:HttpCustomerService,//http请求连接
     private native:NativeService,
     public keyboard:Keyboard,
     public alertCtrl:AlertController,
     public modalCtrl:ModalController,
     public actionSheetCtrl:ActionSheetController,
     public popoverCtrl:PopoverController,
     private device:Device,
     private emitservice: EmitserviceService
  ) {
    this.initializeApp();
  }
  loginOut() {
    this.common.LoginOut();
  }
  SubMenusOpen(root: any) {
    this.menusC.toggle();
    
   if(root.Url){
    this.common.Go('/tabs/'+root.Url);
   }
  }
  initializeApp() {
    const that = this;
    // that.getBrowserKernel();
    that.initRouterListen();
    if(!app.VISIT){//判断是否只能微信打开，true 所有方式都可以打开
      if(!that.common.IsWeixinBrowser){
        window.location.href="/assets/pageinfo.htm";
      }
    }else{//true  浏览器打开时 自动退出
      if(!that.common.IsWeixinBrowser){
        that.isweixinChanageTimeOut();//判断多长时间退出登录
      }
     
    }
    that.platform.ready().then(() => {
      console.log(that.common.isWxIOS,"微信IOS系统登录");
      if (that.platform.is("cordova")) {
        that.screen.lock(that.screen.ORIENTATIONS.PORTRAIT_PRIMARY);//防止屏幕旋转
        // that.downLoadInstall();//根据连接热更新
        if(that.platform.is("ios")){
          that.isIosPlatform = true;
        }
        if(that.platform.is("android")){
          that.isAndroidPlatform = true;
          that.MobileModel();
          that.statusBar.overlaysWebView(true);
          // that.registerBackButtonAction();
          that.platform.resume.subscribe();
          if(that.device.version){//版本号存在
            if(that.device.version.toString().startsWith("5")){//当前版本小于等于5.0
              that.isAndroid5 = true;//等于5
              that.isAndroid5Down = true;
              that.isAndroid4 = false;
            }else if(that.device.version.toString().startsWith("4")){//当前版本小于等于4.0
              that.isAndroid5Down = true;//小于5.0
              that.isAndroid4 = true;
            }else if(that.device.version.toString().startsWith("3")){//当前版本小于等于3.0
              that.isAndroid5Down = true;//小于5.0
              that.isAndroid4 = true;
            }
          }
        }
      }
      else{
        if(that.common.IsWeixinBrowser){
          let ua:any= window.navigator.userAgent.toLowerCase();
          //         if( (ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork') ){
          //            console.log("企业微信打开");
          //         }else{
          //           console.log(that.common.isWxIOS,"微信IOS系统登录");
          //           that.msg.Alert("请在企业微信中打开").then(data=>{
          //             if(data){
          //               that.common.CloseWeixin();
          //             }
          //           });
          //         }
          // if(!that.common.isWxIOS){
              //#region  硬件返回事件处理
                      history.pushState(null, null, document.URL);
                    window.addEventListener("popstate", async(e)=>{
                      // alert("我监听到了浏览器的返回按钮事件啦");//根据自己的需求实现自己的功能
                      console.log("返回按钮...微信端");
                      history.pushState(null, null,document.URL);
                      // window.location.href="/";
                      //  console.log( that.url);
                        try{
                          that.keyboard.hide();//键盘事件
                          const alert = await that.alertCtrl.getTop();
                          if(alert){
                            if(!that.common.GetStorageKey("ISCLOSE")){
                              that.isbackButton=false;
                              alert.dismiss();
                            }else{
                              that.msg.Show("请先操作弹出框");
                            }
                            return;
                          }
                          const action  =await that.actionSheetCtrl.getTop();
                          if(action){
                            that.isbackButton=false;
                            action.dismiss();
                            return;
                          }
                          const popover = await that.popoverCtrl.getTop();
                          if(popover){
                            that.isbackButton=false;
                            popover.dismiss();
                            return;
                          }
                          const modal = await that.modalCtrl.getTop();
                          if(modal){
                            that.isbackButton=false;
                            modal.dismiss();
                            return;
                          }
                          const isOpen = await that.menusC.isOpen();
                          if(isOpen){
                            that.isbackButton=false;
                            that.menusC.close();
                            return;
                          }
                    
                          const dateTime2:any = document.getElementsByClassName("ios-select-widget-box");
                          if(dateTime2.length > 0){
                            for(let i = 0;i < dateTime2.length;i++){
                              dateTime2[i].remove();
                            }
                            return;
                          }
                        }catch(error){
                    
                        }
                        console.log(that.url,"返回菜单名称");
                        if(that.url.trim()){
                          if(that.url.indexOf("login")>=0 || that.url=="/" ){
                            history.pushState(null, null,null);
                            return;
                          }else
                          if(that.url.indexOf("ScheduleSetting")>=0){
                            that.msg.Confirm("您确定放弃当前排班吗?","取消","放弃").then(fail=>{
                              that.isbackButton=false;
                                if(fail){
                                  localStorage.removeItem("backurl");
                                  that.common.Go("/login?version="+that.common.getNowDatetime);
                                }else{
                                  return;
                                }
                            });
                          }else
                          if(that.url.indexOf(that.common.getHonmeUrl().Component)>=0){
                            if(!that.isbackButton){
                                that.isbackButton=true;
                                that.msg.Confirm("确定退出系统吗?","取消","退出").then(fail=>{
                                  that.isbackButton=false;
                                    if(fail){
                                    that.common.CloseWeixin();
                                    }
                                });
                            }
                        }else{
                          //#region  解决硬件二维码页面返回时 妈妈班 扫码销量 以及 扫活动码时返回业务处理方案
                            if(that.common.GetStorageKey("orderQRCode")){//如果妈妈鲜入为主过来的扫活动码都需要回传
                              that.emitservice.eventEmit.emit({
                                "orderQRCode":"扫码"
                              });
                            }
                            if(that.common.GetStorageKey("orderQRID")){//如果是扫码销量返回需要回传
                              let objOrderCode:any=that.common.GetStorageKey("orderQRID");
                              that.emitservice.eventEmit.emit(objOrderCode);
                            }
                            //#endregion
                            if(that.url.indexOf("qrcode")!=-1){//二维码页面
                              if(localStorage.getItem("ordermarstID")){//扫码销量二维码页面
                                let _userOrderNum:string=localStorage.getItem("ordermarstID");
                                console.log(_userOrderNum,"订单号码");
                                that.getUserinfo(_userOrderNum);
                              }else{
                                setTimeout(()=>{
                                  that.common.goBack();
                                },50);
                              }
                              }else{
                              setTimeout(()=>{
                                that.common.goBack();
                              },50);
                              }
                        }
                        }else{
                          if(!that.isbackButton){
                              that.isbackButton=true;
                              that.msg.Confirm("确定退出系统吗?","取消","退出").then(fail=>{
                                that.isbackButton=false;
                                if(fail){
                                that.common.CloseWeixin();
                                }
                            });
                          }
                        }
                      return;
                    }, false);  
              //#endregion
          // }
        }
      }
      that.statusBar.styleDefault();
      that.splashScreen.hide();
      // console.log(this.isIosPlatform,this.isAndroidPlatform);
    });
  }
  pushHistory() {
    var state = {
        title: "title",
        url: "#"
    };
    window.history.pushState(state, state.title, state.url);
  }
  /**
   * 安装环境变量
   */
  downLoadInstall(){
    let that=this;
    let httptempUrl:any="";//json文件下载地址
    if(app.RELEASE){
       httptempUrl = app.IOS_INSTALL_URL;
    }else{
      httptempUrl = app.IOS_INSTALL_URL_TEST;
    }
    that.http.get(httptempUrl).then(resu=>{
      let version:any=0;//相同版本
      if(that.platform.is("ios") || that.platform.is("ipad")|| that.platform.is("iphone")){
        version=resu.ios.version;
      }else if(that.platform.is("android")){//如果是android则versionCode:1001011
        version=Number.parseInt(resu.android.version);
      }
      that.appversion.getVersionCode().then(num=>{
        if(num!=version){
          that.msg.Alert(app.CONTENT,"更新提示","立即更新").then(fail=>{
            if(fail){
              if(that.platform.is("ios") || that.platform.is("ipad")|| that.platform.is("iphone")){
                if(!app.RELEASE){
                  that.iab.create(app.IOS_URL_TEST);
                }else{
                  that.iab.create(app.IOS_URL);
                }
              }else if(that.platform.is("android")){
                that.native.downloadApp()
              }
            }
          });

        }

      });
    });
  }
  // getIosAppVersion(){
  //   let that=this;
  //   that.http.get(app.IOS_INSTALL_URL).then(resu=>{
  //     let version=resu.version;//相同版本
  //     // alert(version);
  //     that.appversion.getVersionCode().then(num=>{
  //       if(num!=version){
  //       that.msg.Alert("发现新版本,请更新","更新提示","立即更新").then(fail=>{
  //         if(fail){
  //           that.iab.create(app.IOS_URL);
  //         }
  //       });
  //       }

  //     });
  //   });
   
  // }
  registerBackButtonAction() {
    const that = this;
    that.customBackActionSubscription = that.platform.backButton.subscribe(() => {
        if (that.common.getMenusUrl(that.url)) {
            if (this.backButtonPressed) {
                this.appMinimize.minimize();
                this.backButtonPressed = false;
            } else {
                that.msg.Show("再按一次退出应用");
                this.backButtonPressed = true;
                setTimeout(() => {
                  this.backButtonPressed = false
                  navigator['app'].exitApp();
                }, 2000);
            }
        } else {
            this.navController.back();
        }
    });
}
@HostListener('document:ionBackButton',['$event'])
private overrideHardwareBackAction($event:any){
  const that = this;
 //  console.log("监听事件...");
   $event.detail.register(100,async()=>{
     console.log("返回按钮...");
    //  console.log( that.url);
     try{
      that.keyboard.hide();//键盘事件
      const alert = await that.alertCtrl.getTop();
      if(alert){
        if(!that.common.GetStorageKey("ISCLOSE")){
          alert.dismiss();
        }else{
          that.msg.Show("请先操作弹出框");
        }
        return;
      }
      const action  =await that.actionSheetCtrl.getTop();
      if(action){
        action.dismiss();
        return;
      }
      const popover = await that.popoverCtrl.getTop();
      if(popover){
        popover.dismiss();
        return;
      }
      const modal = await that.modalCtrl.getTop();
      if(modal){
        modal.dismiss();
        return;
      }
      const isOpen = await that.menusC.isOpen();
      if(isOpen){
        that.menusC.close();
        return;
      }

      const dateTime2:any = document.getElementsByClassName("ios-select-widget-box");
      if(dateTime2.length > 0){
        for(let i = 0;i < dateTime2.length;i++){
          dateTime2[i].remove();
        }
        return;
      }
    }catch(error){

    }
    console.log(that.url,"返回菜单名称");
     if(that.url.trim()){
       if(that.url.indexOf("login")>=0 || that.url=="/" ){
         that.appMinimize.minimize();
         return;
       }else
       if(that.url.indexOf("ScheduleSetting")>=0){
        that.msg.Confirm("您确定放弃当前排班吗?","取消","放弃").then(fail=>{
          that.isbackButton=false;
            if(fail){
              localStorage.removeItem("backurl");
              that.common.Go("/login?version="+that.common.getNowDatetime);
            }else{
              return;
            }
        });
      }else if(that.common.getFirstMenuUrl(that.url)){
         if(!that.isbackButton){
             that.isbackButton=true;
             that.msg.Confirm("确定退出系统吗?","取消","退出").then(fail=>{
               that.isbackButton=false;
                 if(fail){
                   navigator['app'].exitApp();
                 }
             });
         }
      }else{
        //#region  解决硬件二维码页面返回时 妈妈班 扫码销量 以及 扫活动码时返回业务处理方案
          if(that.common.GetStorageKey("orderQRCode")){//如果妈妈鲜入为主过来的扫活动码都需要回传
            that.emitservice.eventEmit.emit({
              "orderQRCode":"扫码"
            });
          }
         if(that.common.GetStorageKey("orderQRID")){//如果是扫码销量返回需要回传
            let objOrderCode:any=that.common.GetStorageKey("orderQRID");
            that.emitservice.eventEmit.emit(objOrderCode);
          }
          //#endregion
         if(that.url.indexOf("qrcode")!=-1){//二维码页面
           that.common.goBack(false);
         }else{
          that.common.goBack();
         }
      }
     }else{
       if(!that.isbackButton){
           that.isbackButton=true;
           that.msg.Confirm("确定退出系统吗?","取消","退出").then(fail=>{
             that.isbackButton=false;
             if(fail){
               navigator['app'].exitApp();
             }
         });
       }
     }
   return;
   });
 }
 
  /**
   * formInfo
   * true 关联了妈妈班 false未关联
   * @param formInfo 
   */
  deleteSignInfo(formInfo, type){
    const that = this;
    const OrderId = localStorage.getItem("milkActivityOrder");
    let FormID = null;
    if(formInfo && formInfo["a_ID"]){
      FormID = formInfo["a_ID"];
    }
    let _body = {
      FromID:FormID,
    }
    //未关联妈妈班并且订单号存在
    if(OrderId){
      _body["OrderId"] = OrderId;
    }
    let _obj = {
      "ConfigName": "DelActivitySignInfo",
      "OpType": "query",
      "ConfigType": "view",
      "RequestBody": JSON.stringify(_body)
    };
    that.http.post(app.DEFAULTURL, _obj);
  }
getBrowserKernel(){
  let ua = navigator.userAgent;
  let key="TBS/";
  let start =ua.indexOf(key);
  if(start!==-1){
      alert("X5内核");
  }else{
      alert("系统内核");
  }
}
  // registerBackButtonAction() {
  //   let that = this;
  //   that.customBackActionSubscription = this.platform.backButton.subscribe(() => {
  //     if (that.backButtonPressed) {
  //       if (!that.backExitApp) {
  //         that.backExitApp = true;
  //         that.msg.Confirm("确定退出程序吗？").then(data => {
  //           that.backButtonPressed = false;
  //           that.backExitApp = false;
  //           if (data) {
  //             navigator['app'].exitApp();
  //           } else {
  //             that.router.initialNavigation();
  //           }
  //         });
  //       }
  //     } else {
  //       if (!that.backExitApp) {
  //         that.backButtonPressed = true;
  //         if (that.common.getMenusUrl(that.url)) {
  //           that.router.dispose();
  //           that.router
  //           that.backExitApp = true;
  //           that.msg.Confirm("确定退出程序吗？").then(data => {
  //             that.backButtonPressed = false;
  //             that.backExitApp = false;
  //             if (data) {
  //               navigator['app'].exitApp();
  //             } else {
  //               that.router.initialNavigation();
  //             }
  //             setTimeout(function () {
  //               that.backButtonPressed = false;
  //             }, 2000);
  //           });
  //         }
  //         else {
  //           setTimeout(function () {
  //             that.backButtonPressed = false;
  //           }, 2000);
  //           that.router.initialNavigation();
  //         }
  //       }
  //     }
  //   });
  // }
  initRouterListen() {
    const that = this;
      console.log("info_1008611");
    that.router.events.subscribe(event => { // 需要放到最后一个执行
      if(event instanceof NavigationStart){
        // console.log(event.url);
        // if(event.url !="/"){
        //   that.msg.Loading("请稍后...","load").then((lod)=>{
        //     lod.present();
        //    });
        // }
      }
      if (event instanceof NavigationEnd) {
       
            
        that.url = event.url;
        if (that.common.getFirstMenuUrl(that.url)) {
          that.base.IsMenusHome = true;
          //  if(that.base.UrlAction){
          //   that.base.UrlAction = that.common.replaceMenusUrl(that.url);
          //  }
          that.base.IsMenusAction = that.common.getMenuAction(that.url);
        } else {
          that.base.IsMenusHome = false;
          // that.base.UrlAction = undefined;
        }
        that.base.IsDisplayMenus=true;
        if(that.url.indexOf("ScheduleSetting")>-1){
          that.base.IsDisplayMenus=false;
        }
       
        //  console.log(document.getElementsByName("tabs"));

      }
      // if (event instanceof NavigationEnd) {
      //   that.url = event.url;
      //   if(event.url !="/"){
      //     setTimeout(()=>{
      //       that.msg.LoadingDismiss("load");
      //     },1000);
      //   }

      // }
      // if(event instanceof NavigationError){
      //   if(event.url !="/"){
      //     setTimeout(()=>{
      //       that.msg.LoadingDismiss("load");
      //     },1000);
      //   }
      // }
      // if(event instanceof NavigationCancel){
      //   if(event.url !="/"){
      //     setTimeout(()=>{
      //       that.msg.LoadingDismiss("load");
      //     },1000);
      //   }
      // }
    });
  }
  ngAfterViewInit() {
  }

  /**
   * 选择组织
   * @param e 
   */
  selectOrg(e) {
    console.log(e.detail.value);
    if(e.detail.value){
      this.base.Department = e.detail.value;
    }
  }

  //手机型号
  MobileModel(){
    var type = navigator.userAgent;
    if(type && type.indexOf("MI 8") > -1){
      if(document.body){
        document.body.setAttribute("class","alien-screen");
      }
    }
  }
  /**
   * 更具订单号 获取会员信息
   * @param orderID 
   */
  getUserinfo(orderID:string){
    let that = this;
    const PageName = "GetOrderMemberInfo";
    let body = new WebParameterContext();
    body.Account = that.common.GetAccount;
    console.log("跳转页面");
    // that.orderID = "20191217170500004204";
    // that.orderID = "20191319081333230";
    // body.ConfigName="MemberManage";
    body.OpType = "get";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName = "GetOrderMemberInfo";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["a_OrderID"] = orderID;
    body.RequestBody = JSON.stringify(typeObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      console.log(data.Status,"会员信息");
      if (data.ResponseMessage.Success && data.Status) {
        localStorage.setItem("wxuserinfo",JSON.stringify(data.Status));
        that.common.Go("/tabs/contact/WCustomerEntry/view/" + that.common.getNowDatetime);
      } else {
        that.common.goBack();
       console.log(data.ResponseMessage.ErrorMessage,"获取订单会员错误");
      }
    }).catch(error => {
      that.common.goBack();
      console.log(error,"获取订单会员错误error");
    });
  }
    /**
   * 页面触发事件判断长时间不操作退出登录页面
   */
  isweixinChanageTimeOut(){
    const that=this;
    if(!app.SAFEEXITTIME){//如果退出时间小于等于0 方法终止；
      return;
    }
    let timeOut = app.SAFEEXITTIME * 60 * 1000 //设置超时时间: 30分钟
    console.log(timeOut,"默认时间");
    window.onload = function () {
      window.document.onmousedown = function () {
        console.log("页面在触发");
        let now:any=new Date().getTime();
      sessionStorage.setItem("lastTime", now);
      }
     };
     let logintimeOut= setInterval(()=>{
        // console.log("进入判断");
        let currentTime = new Date().getTime() ;    //更新当前时间
       let lastTime = Number.parseInt(sessionStorage.getItem("lastTime"))||0;
       let lastnum:number=currentTime - lastTime;
      //  console.log(lastnum,"剩余时间");
         if ( lastnum > timeOut) { //判断是否超时
            //  clearInterval(logintimeOut);
         // 跳到登陆页
            //  console.log("跳到登陆页");
               if(window.location.href.indexOf("login")<0){
                sessionStorage.clear();
                let out:SysAccount=new SysAccount();
                that.base.account = out;
                that.base.subMenus=[];
                localStorage.setItem("account",JSON.stringify(out));
                that.common.CloseWeixin();
                 sessionStorage.removeItem("_imei");
                that.http.GetLoginOut().then(res=>{
                  console.log(res,"退出登录成功");

                }).catch(err=>{
                  console.log(err,"退出登录失败");
                })
                that.common.LoginOutToken();
               }
             
         }
      },1000);



  }
}
